import { render, staticRenderFns } from "./DownloadMetadataPage.vue?vue&type=template&id=c8a56ad6&scoped=true&lang=pug"
import script from "./DownloadMetadataPage.vue?vue&type=script&lang=js"
export * from "./DownloadMetadataPage.vue?vue&type=script&lang=js"
import style0 from "./DownloadMetadataPage.vue?vue&type=style&index=0&id=c8a56ad6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a56ad6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8a56ad6')) {
      api.createRecord('c8a56ad6', component.options)
    } else {
      api.reload('c8a56ad6', component.options)
    }
    module.hot.accept("./DownloadMetadataPage.vue?vue&type=template&id=c8a56ad6&scoped=true&lang=pug", function () {
      api.rerender('c8a56ad6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/my_tasks/DownloadMetadataPage.vue"
export default component.exports